let OSS = require('ali-oss');
import cache from "@/utils/cache.js"
import { md5 } from 'js-md5';
const base_style = 'image/auto-orient,1/interlace,1/resize,m_lfit,w_1920,h_1920/quality,q_95/watermark,'
const base_style2 = 'image/auto-orient,1/interlace,1/resize,m_lfit,w_1920,h_1920/quality,q_95'

let client = new OSS({
    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
    region: 'oss-cn-shenzhen',
    // 从环境变量中获取访问凭证。运行本代码示例之前，请确保已设置环境变量OSS_ACCESS_KEY_ID和OSS_ACCESS_KEY_SECRET。
    accessKeyId: 'LTAI5tQkuB7ZXwEXvMLcD3is',
    accessKeySecret: '7RdLF9bOpfWWkC21mpez4d4XgXfJk6',
    bucket: 'jcyunxp-v2024-local',
    endpoint: 'oss-cn-shenzhen.aliyuncs.com',
    secure: true
});
const originalSignatureUrl = client.signatureUrl;
client.signatureUrl = function (...args) {
    try {
        let cachename = md5(args[0] + args[1].process)
        let oldurl = cache.getcache(cachename)
        if (oldurl) {
            //console.log('client.signatureUrl from cache', args[0])
            return oldurl
        }
        const url = originalSignatureUrl.apply(this, args);
        let expires = args[1].expires
        if (expires) {
            cache.setcache(cachename, url, expires - 300)
        }
        //console.log('client.signatureUrl new', args[0])
        return url
    } catch (e) {
        const url = originalSignatureUrl.apply(this, args);
        //console.log('client.signatureUrl error', args[0])
        return url
    }
};

export default {
    datestr() {
        const date = new Date();
        const year = date.getFullYear().toString().padStart(4, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hour = date.getHours().toString().padStart(2, '0');
        const minute = date.getMinutes().toString().padStart(2, '0');
        const second = date.getSeconds().toString().padStart(2, '0');
        return `${year}${month}${day}${hour}${minute}${second}`
    },
    url_safe_base64_encode(str) {
        if(!str) return
        var URLSafeBase64 = require('urlsafe-base64');
        var b = new Buffer.from(str);
        var s = b.toString('base64');
        return URLSafeBase64.encode(s);
    },
    url_safe_base64_decode(str) {
        if(!str) return
        var URLSafeBase64 = require('urlsafe-base64');
        var base64Str = URLSafeBase64.decode(str);

        var b = new Buffer.from(base64Str, 'base64')
        var s = b.toString();
        return s;
    },
    spt() {
        return '_!#$f%$&gf$#!_'
    },
    fromspt(s) {
        let t = s.split(this.spt())
        let ret = { width: t[0], height: t[1], filename: t[2] }
        return ret
    },
    compute_wh(w, h, m) {
        //width原图实际宽度,height原图实际高度,maxlen压缩后最长边像素
        //横片
        let cw//压缩后宽度
        let ch//压缩后高度
        if (w > h) {
            cw = m
            ch = (m * h) / w
        } else {
            //竖片
            ch = m
            cw = (m * w) / h
        }
        let ret = { width: Math.round(cw), height: Math.round(ch) }
        return ret
    },
    get_url(file, process = '') {
        return client.signatureUrl(file, { process: process })
    },
    get_watermark_style(form) {
        try{
            let test=form.text
        }catch(e){
            console.log(e)
            return base_style2
        }
        //text_aGVsbG8gd29ybGRkZGQ,color_ffffff,size_15,rotate_115,fill_1,shadow_20,g_center,t_90,x_1,y_1
        let str = 'text_' + this.url_safe_base64_encode(form.text) + ','
        str = str + 'color_' + form.color.replace('#', '') + ','
        str = str + 'type_ZmFuZ3poZW5naGVpdGk,'//方正黑体
        str = str + 'size_' + form.size + ','
        if (form.rotate != 0) {
            str = str + 'rotate_' + form.rotate + ','
        }
        if (form.fill == 'yes') {
            str = str + 'fill_1' + ','
        }
        str = str + 'shadow_' + form.shadow + ','
        str = str + 'g_' + form.g + ','
        if (form.t < 100) {
            str = str + 't_' + form.t + ','
        }
        str = str + 'x_' + form.x + ','
        str = str + 'y_' + form.y
        return base_style + str
    },
    get_watermark_style_default2(text){
        let str = 'text_' + this.url_safe_base64_encode(text) + ',color_FFFFFF,type_ZmFuZ3poZW5naGVpdGk,size_55,shadow_57,g_se,t_75,x_60,y_60'
        return base_style + str
    },
    get_watermark_style_default3(text){
        let str = 'text_' + this.url_safe_base64_encode(text) + ',color_FFFFFF,type_ZmFuZ3poZW5naGVpdGk,size_30,rotate_325,fill_1,shadow_0,g_center,t_22,x_10,y_10'
        return base_style + str
    },
    async get_list(fullpath, style,force=false) {
        return new Promise(async (resolve) => {
            if(fullpath.indexOf('upload/demo/')!=-1){
                fullpath=fullpath.replace('upload/demo/','demo/demo/')
            }
            let cachefiles=cache.getcache('oss_list')
            if(!force && cachefiles && cachefiles.length!=0){
                console.log('oss_list from cache',cachefiles)
                resolve(cachefiles)
                return
            }
            let marker = null;
            const maxKeys = 100;// 每页列举20个文件。
            let files = []
            do {
                const result = await client.list({
                    marker: marker,
                    'max-keys': maxKeys,
                    prefix: fullpath
                });
                marker = result.nextMarker;
                files = files.concat(result.objects)
            } while (marker);
            files=files.filter(file=>file.name!=fullpath)
            for (const file of files) {
                let pos = file.name.lastIndexOf('/')
                let arr = this.fromspt(file.name.substr(pos + 1))
                file.width = arr.width
                file.height = arr.height
                file.filename = arr.filename
                file.signatureUrl = client.signatureUrl(file.name, {
                    expires: 3600,
                    process: 'image/auto-orient,1/interlace,1/resize,m_lfit,w_280,h_280/quality,q_90' // 设置图片处理参数。
                });
                //大图
                file.signatureUrl_Big = client.signatureUrl(file.name, {
                    expires: 3600,
                    process: style // 设置图片处理参数。
                });
                //file.info=await this.getInfo(file.name)
                file.selected = false
            }
            console.log('get_list before sort', files);
            files.sort(function (a, b) {
                return a.filename.toLocaleLowerCase().localeCompare(b.filename.toLocaleLowerCase())
            })
            console.log('get_list', files);
            cache.setcache('oss_list', files, 10) 
            resolve(files)
            //files = files.filter(item => item.name != 'upload/')
            //console.log('get_list',files);
        })
    }
}